import styled from '@emotion/styled'

export const Item = styled('div')`
  display: flex;
  align-items: center;
  padding: 12px 8px;
  height: 44px;
  border: ${props => props.theme.gray4} 1px solid;
`
